import { createSelector } from '@reduxjs/toolkit';
import { CandleApi } from '@voladeum/client';
import { RootState } from 'store';

const candlesSlice = (state: RootState) => state.candles;

export const selectCandles = createSelector([candlesSlice], (state): CandleApi[] => state);
